module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\n<span class="table_AffectationPrincipale"></span>\n<span class="table_AffectationRemplacement"></span>\n<span class="table_AffectationComplementaire"></span>';
}
return __p;
};
